import { render } from "./UserSkeleton.vue?vue&type=template&id=fc4bc578&scoped=true"
const script = {}

import "./UserSkeleton.vue?vue&type=style&index=0&id=fc4bc578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4bc578"]])

export default __exports__